import { render, staticRenderFns } from "./MarriageReportOneResult.vue?vue&type=template&id=2b83bf62&"
import script from "./MarriageReportOneResult.vue?vue&type=script&lang=js&"
export * from "./MarriageReportOneResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports